module.exports = __webpack_public_path__ + "static/img/fitLife.5f00212.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/fitLife.png
// module id = E+dc
// module chunks = 1